// extracted by mini-css-extract-plugin
export default {"icon":"xSm1zK"};